import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { DadosContextoEmbarqueRedux } from "./contexts/ContextoEmbarque";
import { CoresRedux } from "./contexts/Cor";
import { CoresContext } from "./contexts/Cor.tsx";
import { EmbarqueDependenciasProvider } from "./contexts/EmbarqueDependenciasContext.tsx";
import { DadosFilialRedux } from "./contexts/FilialContext.tsx";
import { FiltroProvider } from "./contexts/FiltroContext.tsx";
import { FiltrosRedux } from "./contexts/Filtros";
import { MenusRedux } from "./contexts/Menus";
import { MenusProvider } from "./contexts/Menus.tsx";
import { MultiplosFiltrosRedux } from "./contexts/MultiplosFiltros";
import { NomeTabelaRedux } from "./contexts/NomeTabela";
import { NomeTabelaProvider } from "./contexts/NomeTabela.tsx";
import { ProfileProvider } from "./contexts/ProfileContext.tsx";
import { RastrearRedux } from "./contexts/Rastreio";
import { RequestControllerRedux } from "./contexts/RequestController";
import { TabelaRedux } from "./contexts/Tabela";
import { ToastProvider } from "./contexts/ToastContext.tsx";
import { DadosUsuarioRedux } from "./contexts/Usuario";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<Router>
			<RequestControllerRedux>
				<ToastProvider>
					<MenusRedux>
						<MenusProvider>
							<CoresContext>
								<DadosContextoEmbarqueRedux>
									<TabelaRedux>
										<NomeTabelaProvider>
											<DadosFilialRedux>
												<DadosUsuarioRedux>
													<CoresRedux>
														<NomeTabelaRedux>
															<FiltrosRedux>
																<EmbarqueDependenciasProvider>
																	<ProfileProvider>
																		<FiltroProvider>
																			<RastrearRedux>
																				<MultiplosFiltrosRedux>
																					<App />
																				</MultiplosFiltrosRedux>
																			</RastrearRedux>
																		</FiltroProvider>
																	</ProfileProvider>
																</EmbarqueDependenciasProvider>
															</FiltrosRedux>
														</NomeTabelaRedux>
													</CoresRedux>
												</DadosUsuarioRedux>
											</DadosFilialRedux>
										</NomeTabelaProvider>
									</TabelaRedux>
								</DadosContextoEmbarqueRedux>
							</CoresContext>
						</MenusProvider>
					</MenusRedux>
				</ToastProvider>
			</RequestControllerRedux>
		</Router>
	</React.StrictMode>
);

reportWebVitals();
